import { API } from '../../../common/api'
import { azureMarketplaceServiceUrl } from '../../../common/utils/constants'
import { GetRevenueInsightsReportV2 } from '../../modules/revenueInsightsV2/actions'
export const fetchAzureProductsList = (partnerId: string) => {
  return API.get(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/products`,
    {
      params: {
        include: 'plans',
      },
    }
  )
}

export const fetchAzurePublicProductsList = (partnerId: string) => {
  return API.get(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/public-products`
  )
}

export const getAzureContractsData = (
  partnerId: string,
  productId: string,
  pageSize?: number,
  pageNumber?: number,
  status?: string,
  expiringDays?: string
) => {
  return API.get(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/products/${productId}/contracts`,
    {
      params: {
        page_size: pageSize || 30,
        page_number: pageNumber || 1,
        include: 'dimensions',
        ...(status ? { status } : {}),
        ...(expiringDays ? { expiring_days: expiringDays } : {}),
        sort_by: 'end_date',
        sort_order: 'ASC',
      },
    }
  )
}

export const getAllAzureContractsData = (
  partnerId: string,
  pageSize?: number,
  pageNumber?: number,
  status?: string,
  expiringDays?: string
) => {
  return API.get(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/contracts`,
    {
      params: {
        page_size: pageSize || 30,
        page_number: pageNumber || 1,
        include: 'dimensions',
        ...(status ? { status } : {}),
        ...(expiringDays ? { expiring_days: expiringDays } : {}),
        sort_by: 'end_date',
        sort_order: 'ASC',
      },
    }
  )
}

export const postAzureContractsData = (
  data: Record<string, unknown>,
  partnerId: string
) => {
  return API.post(
    `${azureMarketplaceServiceUrl}/account/${partnerId}/meterings`,
    data
  )
}

export const postAzurePrivateOffer = ({
  partnerId,
  data,
  saveAsDraft,
}: {
  partnerId: string
  data: Record<string, unknown>
  saveAsDraft?: boolean
}) => {
  return API.post(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/private_offers`,
    data,
    {
      params: {
        draft: saveAsDraft || false,
      },
    }
  )
}

export const getAzureSinglePrivateOffer = (
  partnerId: string,
  privateOfferId: string,
  crmOpportunityId?: string,
  productId?: string
) => {
  return API.get(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/private_offers/${privateOfferId}`,
    {
      params: {
        product_id: productId,
        crm_opportunity_id: crmOpportunityId,
      },
    }
  )
}

export const patchAzurePrivateOffersData = (
  partnerId: string,
  privateOfferId: string,
  data: Record<string, unknown>,
  saveAsDraft?: boolean
) => {
  return API.patch(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/private_offers/${privateOfferId}`,
    data,
    {
      params: {
        draft: saveAsDraft,
      },
    }
  )
}

export const getAzurePrivateOffersData = ({
  partnerId,
  pageSize,
  pageNumber,
  productId,
  crmOpportunityId,
  expiringInDays,
  offerStatus,
}: {
  partnerId: string
  productId?: string
  pageSize?: number
  pageNumber?: number
  crmOpportunityId?: string
  expiringInDays?: string
  offerStatus?: string[]
}) => {
  return API.get(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/private_offers`,
    {
      params: {
        page_size: pageSize,
        page_number: pageNumber,
        sort_by: 'created_at',
        sort_order: 'DESC',
        crm_opportunity_id: crmOpportunityId,
        ...(productId ? { product_id: productId } : {}),
        ...(expiringInDays ? { expiry_days: expiringInDays } : {}),
        ...(offerStatus?.length
          ? { offer_status: offerStatus?.join(',') }
          : {}),
      },
    }
  )
}

export const postMicrosoftResaleAuthorization = ({
  partnerId,
  data,
  saveAsDraft,
}: {
  partnerId: string
  data: Record<string, unknown>
  saveAsDraft?: boolean
}) => {
  return API.post(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/mppos`,
    data,
    {
      params: {
        draft: saveAsDraft || false,
      },
    }
  )
}

export const cloneMicrosoftResaleAuthorization = ({
  partnerId,
  data,
  saveAsDraft,
  cloneId,
}: {
  partnerId: string
  data: Record<string, unknown>
  saveAsDraft?: boolean
  cloneId?: string
}) => {
  return API.post(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/mppos/${cloneId}/clone`
  )
}

export const patchMicrosoftResaleAuthorization = ({
  partnerId,
  data,
  saveAsDraft,
  resaleAuthorizationId,
  editOffer,
}: {
  partnerId: string
  data: Record<string, unknown>
  saveAsDraft?: boolean
  resaleAuthorizationId: string
  editOffer?: boolean
}) => {
  return API.patch(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/mppos/${resaleAuthorizationId}`,
    data,
    {
      params: {
        ...(!editOffer ? { draft: saveAsDraft || false } : {}),
        ...(editOffer ? { edit_offer: true } : {}),
      },
    }
  )
}

export const patchResetMicrosoftResaleAuthorization = ({
  partnerId,
  resaleAuthorizationId,
}: {
  partnerId: string
  resaleAuthorizationId: string
}) => {
  return API.patch(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/mppos/${resaleAuthorizationId}/reset`
  )
}

export const getMicrosoftResaleAuthorization = ({
  partnerId,
  resaleAuthorizationId,
  crmOpportunityId,
}: {
  partnerId: string
  resaleAuthorizationId: string
  crmOpportunityId?: string
}) => {
  return API.get(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/mppos/${resaleAuthorizationId}`,
    {
      params: {
        crm_opportunity_id: crmOpportunityId,
      },
    }
  )
}

export const reminderMicrosoftResaleAuthorization = ({
  partnerId,
  data,
  resaleAuthorizationId,
}: {
  partnerId: string
  data: Record<string, unknown>
  saveAsDraft?: boolean
  resaleAuthorizationId: string
}) => {
  return API.patch(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/mppos/${resaleAuthorizationId}/reminders`,
    data
  )
}

export const getAzureMpposData = ({
  partnerId,
  pageSize,
  pageNumber,
  productId,
  crmOpportunityId,
  expiryDays,
  offerStatus,
}: {
  partnerId: string
  pageSize?: number
  pageNumber?: number
  productId?: string
  crmOpportunityId?: string
  expiryDays?: string
  offerStatus?: string[]
}) => {
  return API.get(`${azureMarketplaceServiceUrl}/partners/${partnerId}/mppos`, {
    params: {
      page_size: pageSize || 10,
      page_number: pageNumber || 1,
      sort_by: 'created_at',
      sort_order: 'DESC',
      ...(expiryDays ? { expiry_days: Number(expiryDays) } : {}),
      ...(offerStatus?.length ? { offer_status: offerStatus?.join(',') } : {}),
      ...(productId ? { product_id: productId } : {}),
      ...(crmOpportunityId ? { crm_opportunity_id: crmOpportunityId } : {}),
    },
  })
}

export const getAzureRevenueReports = ({
  partnerId,
  finalStartDate,
  finalEndDate,
  pageSize,
  pageNumber,
  productId,
}: GetRevenueInsightsReportV2) => {
  return API.get(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/revenues`,
    {
      params: {
        from_date: finalStartDate,
        to_date: finalEndDate,
        page_size: pageSize,
        page_number: pageNumber,
        ...(productId ? { product_id: productId } : {}),
      },
    }
  )
}
export const sendAzurePrivateOfferReminder = (
  partnerId: string,
  privateOfferId: string,
  data: Record<string, unknown>,
  resendOffer?: boolean
) => {
  return API.patch(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/private_offers/${privateOfferId}/reminders`,
    data,
    {
      params: {
        resend: resendOffer || false,
      },
    }
  )
}

export const cloneMicrosoftPrivateOfferAPI = ({
  partnerId,
  cloneId,
}: {
  partnerId: string
  cloneId?: string
}) => {
  return API.post(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/private_offers/${cloneId}/clone`
  )
}

export const resetMicrosoftPrivateOfferAPI = ({
  partnerId,
  offerId,
}: {
  partnerId: string
  offerId?: string
}) => {
  return API.patch(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/private_offers/${offerId}/reset`
  )
}

export const postPublicProducts = ({
  partnerId,
  data,
}: {
  partnerId: string
  data: string[]
}) => {
  return API.post(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/public-products`,
    data
  )
}

export const postMicrosoftProduct = ({
  partnerId,
  data,
}: {
  partnerId: string
  data: Record<string, unknown>
}) => {
  return API.post(
    `${azureMarketplaceServiceUrl}/partners/${partnerId}/public-products/migrate`,
    data
  )
}

export const getMicrosoftCombinedForm = ({ formId }: { formId: string }) => {
  return API.get(`${azureMarketplaceServiceUrl}/combined_offer_form/${formId}`)
}

export const putMicrosoftCombinedForm = ({
  formId,
  data,
}: {
  formId: string
  data: Record<string, unknown>
}) => {
  return API.put(
    `${azureMarketplaceServiceUrl}/combined_offer_form/${formId}`,
    data
  )
}
